import { useEffect, useState } from "react";

const KEY = "sln_cookie_consent";
const EVENT = "sln-consent-change";

export const getConsent = () => {
  try {
    return localStorage.getItem(KEY);
  } catch {
    return null;
  }
};

export const setConsent = (value) => {
  try {
    if (value) localStorage.setItem(KEY, value);
    else localStorage.removeItem(KEY);
  } catch {
    /* storage unavailable */
  }
  window.dispatchEvent(new CustomEvent(EVENT, { detail: value }));
};

export const useConsent = () => {
  const [consent, set] = useState(getConsent);
  useEffect(() => {
    const onChange = (e) => set(e.detail ?? getConsent());
    window.addEventListener(EVENT, onChange);
    return () => window.removeEventListener(EVENT, onChange);
  }, []);
  return consent;
};
